// eslint-disable-next-line import/prefer-default-export
export const GET_MY_APPROVAL_OVERTIME_REQUESTS_SUCCESS =
  'GET_MY_APPROVAL_OVERTIME_REQUESTS_SUCCESS';
export const GET_MY_APPROVAL_OVERTIME_REQUESTS_ERROR =
  'GET_MY_APPROVAL_OVERTIME_REQUESTS_ERROR';
export const GET_MY_APPROVAL_OVERTIME_REQUESTS_PENDING =
  'GET_MY_APPROVAL_OVERTIME_REQUESTS_PENDING';
export const SET_MY_APPROVAL_OVERTIME_REQUESTS =
  'SET_MY_APPROVAL_OVERTIME_REQUESTS';

export const GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_SUCCESS =
  'GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_SUCCESS';
export const GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_ERROR =
  'GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_ERROR';
export const GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_PENDING =
  'GET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS_PENDING';
export const SET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS =
  'SET_MY_APPROVAL_TIME_ADJUSTMENT_REQUESTS';
export const SET_APPROVAL_DROPDOWN_FILTER_COUNTRY =
  'SET_APPROVAL_DROPDOWN_FILTER_COUNTRY';
